import { useTranslation } from 'react-i18next';
import React, {useState, useEffect, Fragment} from 'react';
import { useParams } from "react-router-dom";
import apiRequest from '../../functions/api';
import { Paper, Typography,Table,TableBody,TableCell,TableContainer,TableRow, Box, Grid} from "@mui/material";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
//import CallIcon from '@mui/icons-material/Call';
//import MailIcon from '@mui/icons-material/Mail';
function AddressSearchDetails(props) {
  const { t } = useTranslation();
  let { key } = useParams();
  const { accessToken,  client} = props;
  const [isLoading, setIsLoading] = useState(true);
  const [adresse, setAdresse] = useState(null);
  const {hideMessage, showErrorMessage} = useMessage();
 
  
  useEffect(() => {
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "ADRWEB",
      "statement": "LADE_DETAILS", 
      "adresskey": key,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, adresseCb);
    // eslint-disable-next-line
  }, [])
  const adresseCb = (response) => {
    if (response.status === 200) {
        setAdresse(response.data.adress);
        setIsLoading(false);
        hideMessage();
    } else {
        if (response) {
          showErrorMessage(response.data.message);
        } else {
          showErrorMessage(t("Keine Internetverbindung"));
        }
    }
}
  
  if (isLoading) {
    return <LoadingComponent />
  }
  
  if (window.cordova) {
    return (
      <Fragment>
        <Box pt={2}>
          <Typography color="primary" variant="h5">{adresse.name}</Typography>
        </Box>
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table>           
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <Typography variant="body2">{t("Firma")}</Typography>
                        <Typography variant="body1">{adresse.firma}</Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography variant="body2">{t("Anrede")}</Typography>
                        <Typography variant="body1">{adresse.anrede}</Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography variant="body2">{t("Name, Vorname")}</Typography>
                        <Typography variant="body1">{adresse.name}</Typography>
                      </TableCell>
                    </TableRow>
                    { adresse.abteilung &&
                      <TableRow>
                        <TableCell>
                          <Typography variant="body2">{t("Abteilung")}</Typography>
                          <Typography variant="body1">{adresse.abteilung}</Typography>
                        </TableCell>
                      </TableRow>
                    }
                    { adresse.funktion &&
                      <TableRow>
                        <TableCell>
                          <Typography variant="body2">{t("Funktion")}</Typography>
                          <Typography variant="body1">{adresse.funktion}</Typography>
                        </TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {adresse.mail1 &&
                      <TableRow hover onClick={() => {window.location='mailto:'+adresse.mail1;}}>
                        <TableCell>
                          <Typography variant="body2">{t("E-Mail")}</Typography>
                          <Typography color="primary" variant="body1">{adresse.mail1}</Typography>
                        </TableCell>
                      </TableRow>
                    }
                    {adresse.mail2 &&
                      <TableRow hover onClick={() => {window.location='mailto:'+adresse.mail2;}}>
                        <TableCell>
                          <Typography variant="body2">{t("E-Mail")}</Typography>
                          <Typography color="primary" variant="body1">{adresse.mail2}</Typography>
                        </TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table>           
                  <TableBody>
                    {adresse.tel1 &&
                      <TableRow hover onClick={() => {window.location='tel:'+adresse.tel1;}}>
                        <TableCell>
                          <Typography variant="body2">{t("Telefon geschäftlich")}</Typography>
                          <Typography color="primary" variant="body1">{adresse.tel1}</Typography>
                        </TableCell>
                      </TableRow>
                    }
                    {adresse.tel2 &&
                      <TableRow hover onClick={() => {window.location='tel:'+adresse.tel2;}}>
                        <TableCell>
                          <Typography variant="body2">{t("Telefon geschäftlich")}</Typography>
                          <Typography color="primary" variant="body1">{adresse.tel2}</Typography>
                        </TableCell>
                      </TableRow>
                    }
                    {adresse.mobil1 &&
                      <TableRow hover onClick={() => {window.location='tel:'+adresse.mobil1;}}>
                        <TableCell>
                          <Typography variant="body2">{t("Mobiltelefon geschäftlich")}</Typography>
                          <Typography color="primary" variant="body1">{adresse.mobil1}</Typography>
                        </TableCell>
                      </TableRow>
                    }
                    {adresse.mobil2 &&
                      <TableRow hover onClick={() => {window.location='tel:'+adresse.mobil2;}}>
                        <TableCell>
                          <Typography variant="body2">{t("Mobiltelefon privat")}</Typography>
                          <Typography color="primary" variant="body1">{adresse.mobil2}</Typography>
                        </TableCell>
                      </TableRow>
                    }
                    {adresse.hinweis &&
                      <TableRow>
                        <TableCell>
                          <Typography variant="body2">{t("Hinweis")}</Typography>
                          <Typography variant="body1">{adresse.hinweis}</Typography>
                        </TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Box>
      </Fragment>
    )
  } else {
    return (
      <Fragment>
      <Box pt={2}>
        <Typography color="primary" variant="h5">Kontakt von {adresse.name}</Typography>
      </Box>
      <Box p={2}>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={10} md={8}>
        <TableContainer component={Paper}>
        <Table>           
          <TableBody>
            <TableRow>
              <TableCell>{t("Firma")}</TableCell>
              <TableCell>{adresse.firma}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t("Anrede")}</TableCell>
              <TableCell>{adresse.anrede}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t("Name, Vorname")}</TableCell>
              <TableCell>{adresse.name}</TableCell>
            </TableRow>
            {adresse.abteilung &&
            <TableRow>
              <TableCell>{t("Abteilung")}</TableCell>
              <TableCell>{adresse.abteilung}</TableCell>
            </TableRow> 
            }
            {adresse.abteilung &&
            <TableRow>
              <TableCell>{t("Funktion")}</TableCell>
              <TableCell>{adresse.funktion}</TableCell>
            </TableRow>
            }
            {adresse.mail1 &&
              <TableRow hover onClick={() => {window.location='mailto:'+adresse.mail1;}}>
                <TableCell>{t("E-Mail")}</TableCell>
                <TableCell>
                  <Typography color="primary" >
                    {adresse.mail1}
                  </Typography>
              </TableCell>
              </TableRow>
            }
            {adresse.mail2 &&
              <TableRow hover onClick={() => {window.location='mailto:'+adresse.mail2;}}>
                <TableCell>{t("weitere E-Mail")}</TableCell>
                <TableCell>
                  <Typography color="primary" >
                    {adresse.mail2}
                  </Typography>
                </TableCell>
              </TableRow>
            }
            {adresse.tel1 &&
              <TableRow hover onClick={() => {window.location='tel:'+adresse.tel1;}}>
                <TableCell>{t("Telefon geschäftlich")}</TableCell>
                <TableCell>
                    <Typography color="primary" >
                      {adresse.tel1}
                    </Typography>
                </TableCell>
              </TableRow>
            }
            {adresse.tel2 &&
              <TableRow hover onClick={() => {window.location='tel:'+adresse.tel2;}}>
                <TableCell>{t("Telefon geschäftlich 2")}</TableCell>
                <TableCell>
                  <Typography color="primary" >
                    {adresse.tel2}
                  </Typography>
                </TableCell>
              </TableRow> 
            }
            {adresse.mobil1 &&
            <TableRow hover onClick={() => {window.location='tel:'+adresse.mobil1;}}>
              <TableCell>{t("Telefon mobil geschäftlich")}</TableCell>
              <TableCell>
              <Typography color="primary" >
                {adresse.mobil1}
              </Typography>
              </TableCell>
            </TableRow> 
            }
            {adresse.mobil2 &&
            <TableRow hover onClick={() => {window.location='tel:'+adresse.mobil2;}}>
              <TableCell>{t("Telefon mobil privat")}</TableCell>
              <TableCell>
              <Typography color="primary">
                {adresse.mobil2}
              </Typography>
              </TableCell>
                      </TableRow>
                    }
                    {adresse.hinweis &&
                      <TableRow>
                        <TableCell>{t("Hinweis")}</TableCell>
                        <TableCell>{adresse.hinweis}</TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Box>
      </Fragment>
    )    
  }
}
export default AddressSearchDetails;
